enum CareElementType {
    Subject,
    LabResults,
    VitalSigns,
    ActiveMedication,
    Immunization,
    RiskFactor,
    Spirometry,
    Text,
    TextReviewed,
    BooleanReviewed,
    BooleanTextReviewed,
    IntegerReviewed,
    DecimalReviewed,
    DateOnlyReviewed,
    MultiSelectReviewed,
    AgentDoseReviewed,
    FirstLineReviewed
}

export { CareElementType };
